import React from 'react';
//import Civil from './Civil';

//import Archi from './Archi';
//import Mech from './Mech';

//import className from 'classnames';
import { Link } from "react-router-dom";


import Button from "components/CustomButtons/Button.jsx";

import PropTypes from 'prop-types';
//import AppBar from '@material-ui/core/AppBar';

import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
//import CardActions from '@material-ui/core/CardActions';

import CardMedia from '@material-ui/core/CardMedia';



import civ from "assets/img/cservice.jpg";
import arc from "assets/img/arc1.jpg";
import ic from "assets/img/ictse.jpg";
import por from"assets/img/portse.jpg"; 
import mec from"assets/img/mechse.jpg"; 
import oil from"assets/img/oilse.jpg"; 

const styles = theme => ({
  cardGrid: {
    padding: `${theme.spacing.unit * 5}px 0`
  },
  card: {
    height: '56%',
    display: 'flex',
    flexDirection: 'row',
  },
  cardDetails: {
    width: '600px',
  },
  cardMedia: {
    paddingTop: '46.25%', // 16:9
    },
  cardContent: {
    flexGrow: 1
  },

  title: {
    height: '39%',
    fontWeight: '600',
    fontSize: '1.057rem',
  },
  button: {
    float : 'right',
    postion: 'fixed',
    padding: '10px',
    marginButtom: '10px',
      },

  media: {
    // ⚠️ object-fit is not supported by IE 11.
    objectFit: 'cover',
    
  }
});
const CivilService = [
  {
    title: 'Civil & Structure',
  }
];
const ArchiService = [
  {
    title: 'Architectural',
  }
];
const  MEService= [
  {
    title: 'Mechanical & Electrical',
  }
];
const ICTService = [
  {
    title: 'Information & Communication Technology',
  }
];
const PortService = [
  {
    title: 'Port Operation',
  }
];
const OilService = [
  {
    title: 'Oil & Gas',
  }
];




class SectionServices extends React.Component {
  
   componentDidMount() {
    window.scrollTo(0, 0);
}
  
  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <CssBaseline />
        <Grid container spacing={40} className={classes.cardGrid}>
          {CivilService.map(post => (
            <Grid item key={post.title} xs={12} sm={12} md={4}>
                <CardMedia
                  component="img"
                  alt="Civil Services"
                  className={classes.media}
                  height="200"
                  image={civ}
                  title="Civil & Structure Engineering Services"
                />
               <Divider />
                <Card className={classes.card} >
                   <div className={classes.cardDetails}>
                      <CardContent 
                      height="340"
                      >
                        <Typography component="h2" color="primary" className={classes.title}>
                          {post.title}
                        </Typography>
                        <br/>
                       <Divider />
                     
                      <ul class="fa-ul">
                      <li><span class="fa-li"><i class="fas fa-check-square"></i></span>Construction</li>
                      <li><span class="fa-li"><i class="fas fa-check-square"></i></span>Design & Consultancy</li>
                      <li><span class="fa-li"><i class="fas fa-check-square"></i></span>Project Management</li>
                      </ul>
 
                       <Link to="/civil">
                       <Button
                    color="danger"
                    target="_blank"
                    className={classes.button}
                    > Learn More<i class="material-icons">arrow_right_alt</i>
                    </Button>
                    </Link>
                      
                  
                    </CardContent>
                  </div>                 
                </Card>
             
            </Grid>
          ))}
         
            {ArchiService.map(post => (
            <Grid item key={post.title} xs={12} sm={12} md={4}>
                <CardMedia
                  component="img"
                  alt="Archi Services"
                  className={classes.media}
                  height="200"
                  image={arc}
                  title="Architectural Services"
                />
                    
                <Card className={classes.card} height="100">
                
                    <div className={classes.cardDetails}>
                      <CardContent 
                      height="340"
                      >
                        <Typography component="h3" color="primary" className={classes.title}>
                          {post.title}
                            </Typography>
                           <br/>
                       <Divider />
                       <ul class="fa-ul">
                      <li><span class="fa-li"><i class="fas fa-check-square"></i></span>Site Plan Analysis</li>
                      <li><span class="fa-li"><i class="fas fa-check-square"></i></span>Landscape Design</li>
                      <li><span class="fa-li"><i class="fas fa-check-square"></i></span>Architectural Specification</li>
                      </ul>
                       <Link to="/arch">
                              <Button
                              color="danger"
                              target="_blank"
                              className={classes.button}
                            > Learn More<i class="material-icons">arrow_right_alt</i> 
                           </Button>
                             </Link>
                          </CardContent>
                      </div>
                    </Card>
             </Grid>
          ))}

          {ICTService.map(post => (
            <Grid item key={post.title} xs={12} sm={12} md={4}>
                <CardMedia
                  component="img"
                  alt="ICT Services"
                  className={classes.media}
                  height="200"
                  image={ic}
                  title="Information and Communication Technology Services"
                />
               <Divider />
                <Card className={classes.card} >
                   <div className={classes.cardDetails}>
                      <CardContent 
                      height="340"
                      >
                         <Typography component="h3" color="primary" className={classes.title}>
                          {post.title}
                        </Typography>
                     
                       <Divider />
                         <ul class="fa-ul">
                      <li><span class="fa-li"><i class="fas fa-check-square"></i></span>Software Development</li>
                      <li><span class="fa-li"><i class="fas fa-check-square"></i></span>Cyber Physical System Security</li>
                      <li><span class="fa-li"><i class="fas fa-check-square"></i></span>Industrial Control Systems</li>
                      </ul>
                    
                       <Link to="/ict">
                       <Button
                    color="danger"
                    target="_blank"
                    className={classes.button}
                    > Learn More<i class="material-icons">arrow_right_alt</i>
                    </Button>
                    </Link>
                     
                    
                    </CardContent>
                  </div>                 
                </Card>
             
            </Grid>
          ))}

           {MEService.map(post => (
            <Grid item key={post.title} xs={12} sm={12} md={4}>
                <CardMedia
                  component="img"
                  alt="Mech Services"
                  className={classes.media}
                  height="200"
                  image={mec}
                  title="Mechanical & Electrical Engineering Services"
                />
               <Divider />
                <Card className={classes.card} >
                   <div className={classes.cardDetails}>
                      <CardContent 
                      height="340"
                      >
                         <Typography component="h3" color="primary" className={classes.title}>
                          {post.title}
                        </Typography>
                        <br/>
                       <Divider />
                      <ul class="fa-ul">
                      <li><span class="fa-li"><i class="fas fa-check-square"></i></span>Fire Protection System</li>
                      <li><span class="fa-li"><i class="fas fa-check-square"></i></span> Mechanical Ventilation System</li>
                      <li><span class="fa-li"><i class="fas fa-check-square"></i></span>Electrical System</li>
                      </ul>
                     
                       
                       <Link to="/mech">
                       <Button
                    color="danger"
                    target="_blank"
                    className={classes.button}
                    > Learn More<i class="material-icons">arrow_right_alt</i>
                    </Button>
                    </Link>
                    
                     
                    </CardContent>
                  </div>                 
                </Card>
             
            </Grid>
          ))}
         
          

          {OilService.map(post => (
            <Grid item key={post.title} xs={12} sm={12} md={4}>
                <CardMedia
                  component="img"
                  alt="Oil Services"
                  className={classes.media}
                  height="200"
                  image={oil}
                  title="Oil & Gas Related Services"
                />
               <Divider />
                <Card className={classes.card} >
                   <div className={classes.cardDetails}>
                      <CardContent 
                      height="340"
                      >
                         <Typography component="h3" color="primary" className={classes.title}>
                          {post.title}
                        </Typography>
                      <br/>
                       <Divider />

                        <ul class="fa-ul">
                      <li><span class="fa-li"><i class="fas fa-check-square"></i></span>Storage Tank Design</li>
                      <li><span class="fa-li"><i class="fas fa-check-square"></i></span>Process Piping Layout</li>
                      <li><span class="fa-li"><i class="fas fa-check-square"></i></span>Process Equipment Selection</li>
                      </ul>
                                   
                       <Link to="/oil">
                       <Button
                    color="danger"
                    target="_blank"
                    className={classes.button}
                    > Learn More<i class="material-icons">arrow_right_alt</i>
                    </Button>
                    </Link>
            
                    </CardContent>
                  </div>                 
                </Card>
             
            </Grid>
          ))}


{PortService.map(post => (
            <Grid item key={post.title} xs={12} sm={12} md={4}>
                <CardMedia
                  component="img"
                  alt="Port Services"
                  className={classes.media}
                  height="200"
                  image={por}
                  title="Port Operation and Engineering Services"
                />
               <Divider />
                <Card className={classes.card} >
                   <div className={classes.cardDetails}>
                      <CardContent 
                      height="340"
                      >
                        <Typography component="h3" color="primary" className={classes.title}>
                          {post.title}
                        </Typography>
                         <br/>
                       <Divider />
                       <ul class="fa-ul">
                      <li><span class="fa-li"><i class="fas fa-check-square"></i></span>Port Cranes Technology</li>
                      <li><span class="fa-li"><i class="fas fa-check-square"></i></span>Port Engineering & Automation</li>
                      <li><span class="fa-li"><i class="fas fa-check-square"></i></span>Terminal Operations System</li>
                      </ul>
                     
                     
                       <Link to="/port">
                       <Button
                    color="danger"
                    target="_blank"
                    className={classes.button}
                    > Learn More<i class="material-icons">arrow_right_alt</i>
                    </Button>
                    </Link>
                    </CardContent>
                  </div>                 
                </Card>
            </Grid>
          ))}
        </Grid>
      </React.Fragment>
    );
  }
}

SectionServices.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(SectionServices);



// WEBPACK FOOTER //
// ./src/views/Components/Sections/SectionServices.jsx